import { useState } from "react";
import { useProject } from "../../hooks/useProject";


export default function AddChapter({
  project,
  updateProject
}){
const [ChapterType, setType] = useState("chapter");

const addChapter=()=>{
    const order = {
      prolog: 0,
      chapter: 1,
      epilog: 2
    };
    let chapterID = project.chapters.filter(e => e.type == "chapter").length +1;
    let globalChapterID = project.chapters.length +1;
    let Title;
    switch(ChapterType){
      case "chapter": {
        Title = "Rozdział " + chapterID;
        break;
      }
      case "prolog":{
        Title = "Prolog";
        break;
      }
      case "epilog":{
        Title = "Epilog";
        break;
      }
      case "dodatkowy":{
        Title = "Rozdział dodatkowy";
        break;
      }
      
    }
    const chapter = {
      chapterID: crypto.randomUUID(),
      title: Title, 
      words: 0,
      type: ChapterType,
    };
    const updatedChapters = [...project.chapters, chapter].sort((a, b) => order[a.type] - order[b.type]);
    updateProject({ ...project, chapters: updatedChapters });

  }
    return(
        <div>
            <button onClick={addChapter}>➕ Dodaj</button> <br/>
                <div className="ChapterType">
                  <button type="button" onClick={()=> setType("chapter")} className={ChapterType == "chapter" ? "active" : "" }> 📖 Rozdział </button>
                  <button type="button" onClick={()=> setType("prolog")} className={ChapterType == "prolog" ? "active" : "" }> 🌅 Prolog </button>
                  <button type="button" onClick={()=> setType("epilog")} className={ChapterType == "epilog" ? "active" : "" }> 🌙 Epilog </button>
                  <button type="button" onClick={()=> setType("dodatkowy")} className={ChapterType == "dodatkowy" ? "active" : "" }> ✨️ Rozdział dodatkowy </button>
                </div>
        </div>
    )
}